let helpCentreLocale;
let esimInstallCustomerRef = "";
let installOnCurrent;
let installGuideDeviceType = "";
let installGuideSectionId = "";
let helpCentreIntegrationType = "none";

let currentEsim;

function resetInstallWizard() {
  esimInstallCustomerRef = "";
  installOnCurrent = null;
  installGuideDeviceType = "";
  installGuideSectionId = "";
  currentEsim = null;
}

function appendEsimInstallSlide(slide, hideBack) {
  esimInstallSwiper.appendSlide(slide);
  esimInstallSwiper.update();

  esimInstallNext();

  if (hideBack) {
    document.getElementById("esim-install-back").classList.add("hide");
  } else {
    document.getElementById("esim-install-back").classList.remove("hide");
  }
}

async function openInstallGuideFallback() {
  switch (helpCentreIntegrationType) {
    case "zendesk":
      helpCentreLocale ??= await getZendeskLocale(Shopify.locale + "-" + Shopify.country);
      window
        .open(ZENDESK_URL + "/hc/" + helpCentreLocale + ZENDESK_GUIDES_FALLBACK, "_blank")
        .focus();
    case "api":
      window.open(`${Shopify.routes.root}pages/help`, "_blank").focus();
      break;
    default:
      break;
  }
}

// takes manualInstall or qrInstall
async function openInstallGuide(type) {
  if (!installGuideSectionId) {
    openInstallGuideFallback();
    return;
  }

  if (type) {
    let installGuideUI = `<div class="swiper-slide">
      <div class="popup-guide-article">
        
      </div>
      <div id="install-guide-article-container" class="esim-install-body">
        <div class="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>`;

    appendEsimInstallSlide(installGuideUI);

    let installGuides;
    let installGuide;
    switch (helpCentreIntegrationType) {
      case "zendesk":
        helpCentreLocale ??= await getZendeskLocale(Shopify.locale + "-" + Shopify.country);
        installGuides = await getZendeskArticlesByLabel(
          helpCentreLocale,
          installGuideSectionId,
          type
        );
        installGuide = installGuides.results[0];
        break;
      case "api":
        const helpCentreApi = new window.HelpCentreAPI();
        installGuides = await helpCentreApi.getArticles({
          section: installGuideSectionId,
        });
        installGuide = installGuides.data?.[0];
        break;
      default:
        break;
    }

    if (installGuide) {
      if (helpCentreIntegrationType === "zendesk") {
        let openGuideBtn = document.querySelector( ".popup-guide-article");
        openGuideBtn.querySelector('p').addEventListener('click', function(){
          window.open(installGuide.html_url, '_blank').focus();
        });

        openGuideBtn.querySelector('i').addEventListener('click', function(){
          window.open(installGuide.html_url, '_blank').focus();
        });
      }

      let zdContainer = document.getElementById(
        "install-guide-article-container"
      );
      zdContainer.innerHTML = installGuide.body;
      zdContainer.insertAdjacentHTML(
        "afterEnd",
        `<div class="esim-install-footer">
        <button class="esim-install-footer-button" onclick="esimInstallNeedHelp()">
          <b>${installWizardTranslations.common.need_help}</b>
        </button>
        <div class="esim-install-footer-divider"></div>
        <button class="esim-install-footer-button" onclick="this.blur();esimInstalledCheck()">
          <b>${installWizardTranslations.common.finished}</b>
        </button>
      </div>`
      );

      let smdpContainer = document.getElementById("zd-smdp-plus-addr");
      if (currentEsim.settings.smdpAddress && smdpContainer) {
        smdpContainer.parentElement.style.width = "100%";
        smdpContainer.innerHTML = `<span>${installWizardTranslations.manual_install.smdp_address}</span><div id="zd-smdp-input" class="zd-flex-container"></div>`;

        let smdpField = document.getElementById("zd-smdp-input");
        let smdpInput = document.createElement("input");
        smdpInput.setAttribute("readonly", true);
        smdpInput.value = currentEsim.settings.smdpAddress;
        smdpField.appendChild(smdpInput);
        smdpField.insertAdjacentHTML(
          "beforeend",
          `<i class="material-symbols-outlined" onclick="copyIconValue(this,'${currentEsim.settings.smdpAddress}')">content_copy</i>`
        );
      }

      let activationContainer = document.getElementById(
        "zd-esim-activation-code"
      );
      if (currentEsim.settings.matchingId && activationContainer) {
        activationContainer.parentElement.style.width = "100%";
        activationContainer.innerHTML = `<span>${installWizardTranslations.manual_install.activation_code}</span><div id="zd-activation-input" class="zd-flex-container"></div>`;

        let activationField = document.getElementById("zd-activation-input");
        let activationInput = document.createElement("input");
        activationInput.setAttribute("readonly", true);
        activationInput.value = currentEsim.settings.matchingId;
        activationField.appendChild(activationInput);
        activationField.insertAdjacentHTML(
          "beforeend",
          `<i class="material-symbols-outlined" onclick="copyIconValue(this,'${currentEsim.settings.matchingId}')">content_copy</i>`
        );
      }
    } else {
      esimInstallBack();
      openInstallGuideFallback();
    }
  } else {
    esimInstallBack();
    openInstallGuideFallback();
  }

  return false;
}

function installCheckSuccess() {
  document.getElementById("esim-install-checker").innerHTML = `
  <div class="esim-install-checker">
    <i class="material-symbols-outlined" style="color: #29CA41">check_circle</i>
    <h2>${installWizardTranslations.install_check.success_title}</h2>
    <p>${installWizardTranslations.install_check.success_text}</p>
  </div>
  <div class="esim-install-footer">
  <button class="esim-install-footer-button" onclick="closeEsimInstall()">
    <b>${installWizardTranslations.common.finished}</b>
  </button>
  </div>`;

  esimInstallSwiper.updateAutoHeight();
}

function installCheckError() {
  document.getElementById("esim-install-checker").innerHTML = `
  <div class="esim-install-checker">
    <i class="material-symbols-outlined" style="color: #D80027">error_outline</i>
    <h2>${installWizardTranslations.install_check.error_title}</h2>
    <p>${installWizardTranslations.install_check.error_text}</p>
    <div class="install-checker-error-buttons">
      <button class="button install-guide-outlined-button" onclick="esimInstallNeedHelp()">
        <i class="material-symbols-outlined">help_outline</i>  
        ${installWizardTranslations.install_check.help_button_text}
      </button>
      <button class="button install-guide-outlined-button" onclick="esimInstalledCheck(true)">
        <i class="material-symbols-outlined">refresh</i>  
        ${installWizardTranslations.install_check.retry}
      </button>
    </div>
  </div>
  <div class="esim-install-footer">
    <button class="esim-install-footer-button" onclick="closeEsimInstall()">
      <b>${installWizardTranslations.common.finished}</b>
    </button>
  </div>`;

  esimInstallSwiper.updateAutoHeight();
}

async function esimInstalledCheck(isRetry) {
  let installCheckerLoading = `
    <div class="esim-install-checker">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <h2>${installWizardTranslations.install_check.checking_status}</h2>
      <p>${installWizardTranslations.install_check.please_wait}</p>
    </div>`;

  if (isRetry) {
    document.getElementById("esim-install-checker").innerHTML =
      installCheckerLoading;
    esimInstallSwiper.updateAutoHeight();
  } else {
    installCheckerLoading =
      `<div id="esim-install-checker" class="swiper-slide">` +
      installCheckerLoading +
      "</div>";
    appendEsimInstallSlide(installCheckerLoading, true);
  }

  let esimData = await getEsimAssignmentData(currentEsim);

  if (esimData.profileStatus == "Installed") {
    installCheckSuccess();
  } else {
    installCheckError();
  }
}

function gotAnotherDevice() {
  let haveAnotherDeviceUI = `<div class="swiper-slide">
    <div id="setup-guide-another-device-container" class="esim-install-body">
      <i class="material-symbols-outlined esim-install-intro-icon">devices</i>
      <div class="esim-install-question-container">
        <h2>${installWizardTranslations.another_device.title}</h2>
        <p>${installWizardTranslations.another_device.intro_text}</p>
        <p>${installWizardTranslations.another_device.question}</p>
        <button class="button install-guide-outlined-button" onclick="this.blur();openShareAndScan(false)">
        ${installWizardTranslations.common.yes}
        </button>
        <button class="button install-guide-outlined-button" onclick="this.blur();openManualInstall(true)">
        ${installWizardTranslations.common.no}
        </button>
      </div>
    </div>
    <div class="esim-install-footer">
      <button class="esim-install-footer-button" onclick="esimInstallNeedHelp()">
        <b>${installWizardTranslations.common.need_help}</b>
      </button>
    </div>
  </div>`;

  appendEsimInstallSlide(haveAnotherDeviceUI);
  return false;
}

function openSetupGuideScanQR() {
  let openSetupGuideScanQR = `<div class="swiper-slide">
    <div id="setup-guide-scan-qr-container" class="esim-install-body">
      <div class="esim-install-qr-section">
        <button class="button install-modal-qr-button" onclick="this.blur();renameEsim()">
          <i class="material-symbols-outlined">edit</i>
          ${installWizardTranslations.esim_expert.name}
        </button>
        <img src="${shopifyRootUrl}/${ESIM_APP_PROXY_SUBPATH_PREFIX}/${ESIM_APP_PROXY_SUBPATH}/app/qr/${currentEsim.settings.smdpAddress}/${currentEsim.settings.matchingId}" width="140" height="140" loading="lazy">        
        <button class="button install-modal-qr-button" onclick="this.blur();openShareAndScan(false)">
          <i class="material-symbols-outlined">ios_share</i>
          ${installWizardTranslations.esim_expert.share}
        </button>
      </div>
      <div class="esim-install-question-container">
        <h1>${installWizardTranslations.setup_guide_scan_qr.title}</h1>
        <p>${installWizardTranslations.setup_guide_scan_qr.intro_text}</p>
        <p>
          ${installWizardTranslations.setup_guide_scan_qr.manual_install_text}
          <a onclick="this.blur();openManualInstall(false)"><i class="material-symbols-outlined">ios_share</i> ${installWizardTranslations.setup_guide_scan_qr.manual_install_link_text}</a>
        </p>
        <p style="font-style: italic">
          <b>${installWizardTranslations.common.note}</b>
          ${installWizardTranslations.common.install_time}
        </p>
      </div>
      
        <p>${installWizardTranslations.setup_guide_scan_qr.no_help_centre_install_guide_text}</p>
      
    </div>
    <div class="esim-install-footer">
      <button class="esim-install-footer-button" onclick="esimInstallNeedHelp()">
        <b>${installWizardTranslations.common.need_help}</b>
      </button>
      <div class="esim-install-footer-divider"></div>
      <button class="esim-install-footer-button" onclick="this.blur();esimInstalledCheck()">
        <b>${installWizardTranslations.common.finished}</b>
      </button>
    </div>
  </div>`;

  appendEsimInstallSlide(openSetupGuideScanQR);
  return false;
}

function onSelectDeviceType(sectionId, deviceType) {
  installGuideSectionId = sectionId;
  installGuideDeviceType = deviceType;

  if (installOnCurrent) {
    gotAnotherDevice();
  } else {
    openSetupGuideScanQR();
  }
}

function nonCompatibleDevice(deviceModelName) {
  let nonCompatibleDeviceUI = `<div class="swiper-slide">
    <div id="device-esim-incompatible" class="esim-install-body">
      <i class="material-symbols-outlined" style="color: #D80027">error_outline</i>
      <h2>${installWizardTranslations.device_incompatible.title.replace("{deviceType}", deviceModelName)}</h2>
      <p>${installWizardTranslations.device_incompatible.text}</p>
      <button class="button install-guide-outlined-button" onclick="esimInstallBack()">
        <i class="material-symbols-outlined">replay</i>  
        ${installWizardTranslations.device_incompatible.start_again}
      </button>
    </div>
  </div>`;

  appendEsimInstallSlide(nonCompatibleDeviceUI);
}

function generateDeviceTypeButton(zdData) {
  return `<button class="button install-guide-outlined-button" onclick="this.blur();onSelectDeviceType('${
    'none' == 'zendesk' ? zdData.id : zdData.documentId
  }', '${zdData.name.split(" ")[0]}')">
    ${zdData.name.split(" ")[0]}
  </button>`;
}

async function selectDeviceType(isCurrent) {
  installGuideDeviceType = "";
  installGuideSectionId = "";
  installOnCurrent = isCurrent;
  let deviceTypes = null;

  switch (helpCentreIntegrationType) {
    case "zendesk":
      helpCentreLocale ??= await getZendeskLocale(Shopify.locale + "-" + Shopify.country);
      deviceTypes = await getZendeskSections(helpCentreLocale, ZENDESK_GUIDES_CATEGORY);
      deviceTypes.sort(function (a, b) {
        var articleA = a.name.toUpperCase();
        var articleB = b.name.toUpperCase();
        return articleA < articleB ? -1 : articleA > articleB ? 1 : 0;
      });
      deviceTypes = deviceTypes?.sections ?? [];
      break;
    case "api":
      const helpCentreApi = new window.HelpCentreAPI();
      const sectionsQuery = await helpCentreApi.getSections('xvlaw0mtayxmivliiq6428fd');

      if (sectionsQuery.data) {
        deviceTypes = sectionsQuery.data ?? [];
      }
      break;
    default:
      break;
  }  

  if (deviceTypes) {
    const excludeSections = ('g23hhugad7w1jmrsnf0gm5ht')?.split(',') ?? [];
    deviceTypes = deviceTypes.filter(deviceType => !excludeSections.includes(deviceType.documentId));
    deviceTypes.sort(function (a, b) {
      var sectionA;
      var sectionB;
      sectionA = a.name.toUpperCase();
      sectionB = b.name.toUpperCase();
      return sectionA < sectionB ? -1 : sectionA > sectionB ? 1 : 0;
    });

    if (installOnCurrent && (deviceInfo != null && deviceInfo != undefined && deviceInfo.deviceAtlasProperties != null && deviceInfo.deviceAtlasProperties != undefined && !window.isEmpty(deviceInfo.deviceAtlasProperties))) {
      let deviceCompatibility = getDeviceCompatability(deviceInfo);

      if (!deviceCompatibility.compatible && deviceCompatibility.message == '') {
          nonCompatibleDevice(deviceCompatibility.device);
          return;
      }

      let deviceManufacturerObj = deviceInfo.deviceAtlasProperties.standardisedFullName.split(" ");
      for (let i = 0; i < deviceTypes.length; i++) {
        if (deviceManufacturerObj[0].toLowerCase().includes(deviceTypes[i].name.toLowerCase())) {
          onSelectDeviceType(deviceTypes[i].id, deviceTypes[i].name.split(" ")[0]);
          break;
        };  
      }

      if (installGuideDeviceType) {
        return;
      }
    }
  }

  let selectDeviceTypeUI = `<div class="swiper-slide">
      <div id="setup-guide-welcome-container" class="esim-install-body">
        <i class="material-symbols-outlined esim-install-intro-icon">phone_iphone</i>
        <div class="esim-install-question-container">
          <h2>${installWizardTranslations.select_device_type.title}</h2>
          <p>${installWizardTranslations.select_device_type.question}</p>
          <div id="esim-install-device-types"></div>
        </div>
      </div>
      <div class="esim-install-footer">
        <button class="esim-install-footer-button" onclick="esimInstallNeedHelp()">
          <b>${installWizardTranslations.common.need_help}</b>
        </button>
      </div>
    </div>`;

  appendEsimInstallSlide(selectDeviceTypeUI);

  if (deviceTypes) {
    let deviceTypeButtons = "";
    for (let i = 0; i < deviceTypes.length; i++) {
      deviceTypeButtons =
        deviceTypeButtons +
        generateDeviceTypeButton(deviceTypes[i]);
    }

    document.getElementById("esim-install-device-types").innerHTML =
      deviceTypeButtons;
    esimInstallSwiper.updateAutoHeight();
  }

  return false;
}

function installingOnThisDevice(isCurrent) {
  if (helpCentreIntegrationType === "zendesk" || helpCentreIntegrationType === "api") {
    selectDeviceType(isCurrent);
  } else {
    if (isCurrent) {
      openShareAndScan();
    } else {
      initEsimInstallExpert(false);
    }
  }
}

function initSetupGuide() {
  let setupGuideWelcomeUI = `<div id="setup-guide-welcome-container" class="esim-install-body">
      <i class="material-symbols-outlined esim-install-intro-icon">format_list_numbered</i>
      <h2>${installWizardTranslations.welcome.title}</h2>
      <p>${installWizardTranslations.welcome.intro}</p>
      <div class="esim-install-question-container">
        <h1>${installWizardTranslations.welcome.sub_title}</h1>
        <p>${installWizardTranslations.welcome.question}</p>
        <button class="button install-guide-outlined-button" onclick="this.blur();installingOnThisDevice(true)">
          ${installWizardTranslations.common.yes}
        </button>
        <button class="button install-guide-outlined-button" onclick="this.blur();installingOnThisDevice(false)">
          ${installWizardTranslations.common.no}
        </button>
      </div>
    </div>
    <div class="esim-install-footer">
      <button class="esim-install-footer-button" onclick="esimInstallNeedHelp()">
        <b>${installWizardTranslations.common.need_help}</b>
      </button>
    </div>`;

  document.getElementById("esim-install-heading").innerText = `${installWizardTranslations.common.installing}: ${currentEsim.customerRef && currentEsim.customerRef != '' ? currentEsim.customerRef : currentEsim.iccid}`;

  return setupGuideWelcomeUI;
}

function initEsimInstallExpert(isInitial) {
  const esimInstallExpertUI = `${!isInitial ? "<div class='swiper-slide'>" : ""}<div id="expert-install-container" class="esim-install-body">
      <div class="esim-install-qr-section">
        <button class="button install-modal-qr-button" onclick="this.blur();renameEsim()">
          <i class="material-symbols-outlined">edit</i>
          ${installWizardTranslations.esim_expert.name}
        </button>
        
        <img src="${shopifyRootUrl}/${ESIM_APP_PROXY_SUBPATH_PREFIX}/${ESIM_APP_PROXY_SUBPATH}/app/qr/${currentEsim.settings.smdpAddress}/${currentEsim.settings.matchingId}" width="140" height="140" loading="lazy">
        <button class="button install-modal-qr-button" onclick="this.blur();openShareAndScan(false)">
          <i class="material-symbols-outlined">ios_share</i>
          ${installWizardTranslations.esim_expert.share}
        </button>
      </div>
      <span class="esim-install-iccid">ICCID: ${currentEsim.iccid} <i class="material-symbols-outlined" onclick="copyIconValue(this,'${currentEsim.iccid}')">content_copy</i></span>
      <div class="expert-install-instructions">
        <h3>${installWizardTranslations.esim_expert.sub_title}</h3>
        <p>${installWizardTranslations.esim_expert.intro}</p>
        <p>
          ${installWizardTranslations.esim_expert.share_text}
          <a onclick="this.blur();openShareAndScan()"><i class="material-symbols-outlined">ios_share</i> ${installWizardTranslations.esim_expert.share_and_scan}</a>
        </p>
        <p>
          ${installWizardTranslations.esim_expert.manual_text}
          <a onclick="this.blur();openManualInstall(false)"><i class="material-symbols-outlined">phonelink_setup</i> ${installWizardTranslations.esim_expert.manual_install}</a>
        </p>
        <p style="font-style: italic">
          <b>${installWizardTranslations.common.note}</b>
          ${installWizardTranslations.common.install_time}
        </p>
      </div>
    </div>
    <div class="esim-install-footer">
      <button class="esim-install-footer-button" onclick="esimInstallNeedHelp()">
        <b>${installWizardTranslations.common.need_help}</b>
      </button>
    </div>
  ${!isInitial ? "</div>" : ""}`;

  document.getElementById("esim-install-heading").innerText = installWizardTranslations.esim_expert.title;

  if (isInitial == true) {
    return esimInstallExpertUI;
  }

  appendEsimInstallSlide(esimInstallExpertUI, false);
}

function openShareAndScan(isInitial) {
  let shareAndScanUI = `<div class="swiper-slide">
    <div id="share-scan-container" class="esim-install-body">
      <h2>${installWizardTranslations.share_and_scan.title}</h2>
      <div class="share-scan-qr-code-container">
        <img src="${shopifyRootUrl}/${ESIM_APP_PROXY_SUBPATH_PREFIX}/${ESIM_APP_PROXY_SUBPATH}/app/qr/${currentEsim.settings.smdpAddress}/${currentEsim.settings.matchingId}" width="140" height="140" loading="lazy">
        <button class="share-scan-install-button" onclick="shareEsimQrCode('${shopifyRootUrl}/${ESIM_APP_PROXY_SUBPATH_PREFIX}/${ESIM_APP_PROXY_SUBPATH}/app/qr/${currentEsim.settings.smdpAddress}/${currentEsim.settings.matchingId}', '${currentEsim.iccid}')">
          <i class="material-symbols-outlined">ios_share</i>
          ${installWizardTranslations.share_and_scan.share_button_text}
        </button>
      </div>
      <span class="esim-install-iccid">${installWizardTranslations.share_and_scan.esim_name} ${currentEsim.customerRef != '' ? currentEsim.customerRef : currentEsim.iccid} <i class="material-symbols-outlined" onclick="copyIconValue(this,'${currentEsim.customerRef != '' ? currentEsim.customerRef : currentEsim.iccid}')">content_copy</i></span>
      <p>${installWizardTranslations.share_and_scan.share_instructions}</p>
      
        <p>${installWizardTranslations.share_and_scan.no_help_centre_install_guide_text}</p>
      
    </div>
    <div class="esim-install-footer">
      <button class="esim-install-footer-button" onclick="esimInstallNeedHelp()">
        <b>${installWizardTranslations.common.need_help}</b>
      </button>
      <div class="esim-install-footer-divider"></div>
      <button class="esim-install-footer-button" onclick="this.blur();esimInstalledCheck()">
        <b>${installWizardTranslations.common.finished}</b>
      </button>
    </div>
  </div>`;

  document.getElementById("esim-install-heading").innerText = `${installWizardTranslations.common.installing}: ${currentEsim.customerRef != '' ? currentEsim.customerRef : currentEsim.iccid}`;

  if (isInitial) {
    return shareAndScanUI;
  }

  appendEsimInstallSlide(shareAndScanUI);
}

function copyIconValue(elem, value) {
  navigator.clipboard.writeText(value);
  elem.innerHTML = "check";
  window.setTimeout(function () {
    elem.innerHTML = "content_copy";
  }, 2000);
}
async function openManualInstall(useAltTitle) {
  document.getElementById("esim-install-card").classList.add("block");

  let manualInstallUI = `<div class="swiper-slide">
    <div id="manual-install-container" class="esim-install-body">
      <h1>${
        useAltTitle
          ? installWizardTranslations.manual_install.alt_title
          : installWizardTranslations.manual_install.title
      }</h1>
      <p>${installWizardTranslations.manual_install.intro_text}</p>

      
      <div class="manual-install-details-container">
        <h3>${installWizardTranslations.manual_install.sub_title}</h3>
        
          <p>${installWizardTranslations.manual_install.no_help_centre_install_guide_text}</p>
        
        <span class="esim-install-field-label">${installWizardTranslations.manual_install.smdp_address}</span>
        <div class="esim-install-readonly-field">
          <span>${installWizardTranslations.common.loading}</span>
          <i class="material-symbols-outlined">content_copy</i>
        </div>
        <span class="esim-install-field-label">${installWizardTranslations.manual_install.activation_code}</span>
        <div class="esim-install-readonly-field">
          <span>${installWizardTranslations.common.loading}</span>
          <i class="material-symbols-outlined">content_copy</i>
        </div>
      </div>
    </div>
    <div class="esim-install-footer">
      <button class="esim-install-footer-button" onclick="esimInstallNeedHelp()">
        <b>${installWizardTranslations.common.need_help}</b>
      </button>
      <div class="esim-install-footer-divider"></div>
      <button class="esim-install-footer-button" onclick="this.blur();esimInstalledCheck()">
        <b>${installWizardTranslations.common.finished}</b>
      </button>
    </div>
  </div>`;

  document.getElementById("esim-install-heading").innerText = `${installWizardTranslations.common.installing}: ${currentEsim.customerRef && currentEsim.customerRef != '' ? currentEsim.customerRef : currentEsim.iccid}`;

  esimInstallSwiper.appendSlide(manualInstallUI);
  esimInstallSwiper.update();
  esimInstallNext();

  document.getElementById("esim-install-card").classList.remove("block");

  let dataFields =  document.querySelectorAll('.manual-install-details-container .esim-install-readonly-field')
  
  let smdpAddressField = dataFields[0].querySelector('span')
  smdpAddressField.innerHTML = currentEsim.settings.smdpAddress

  let matchingIdField = dataFields[1].querySelector('span')
  matchingIdField.innerHTML = currentEsim.settings.matchingId

  let smdpAddressCopyIcon = dataFields[0].querySelector('i')
  smdpAddressCopyIcon.onclick = function(){copyIconValue(smdpAddressCopyIcon,currentEsim.settings.smdpAddress)}

  let matchingIdCopyIcon = dataFields[1].querySelector('i')
  matchingIdCopyIcon.onclick = function(){copyIconValue(matchingIdCopyIcon,currentEsim.settings.matchingId)}
  
  let installGuideBtn = document.getElementById('manual-install-guide-button');
  if (installGuideBtn) {
    installGuideBtn.onclick = function(){
      installGuideBtn.blur();
      openInstallGuide('manualInstall');
    }
  }
}

async function renameEsim() {
  document.getElementById("esim-install-card").classList.add("block");
  let esimData = await getEsimAssignmentData(currentEsim);

  openChangeEsimName(
    esimData,
    esimData.customerRef,
    async function (customerRef) {
      esimInstallCustomerRef = customerRef;
      
      await getEsimAssignmentData(currentEsim).then((data) => {
        if (data.message) {
          throw(data.message);
        }

        if (data.customerRef == customerRef) {
          const currentHeaderText = document.getElementById("esim-install-heading").innerText;
          if (currentHeaderText.includes(installWizardTranslations.common.installing)) {
            document.getElementById("esim-install-heading").innerText = `${installWizardTranslations.common.installing}: ${data.customerRef && data.customerRef != '' ? data.customerRef : data.iccid}`;
          }
        }
      })
      .catch(err => closeEsimInstall());
    },
    true
  );

  document.getElementById("esim-install-card").classList.remove("block");
}

function toDataURL(url, callback) {
  var xhr = new XMLHttpRequest();
  xhr.onload = function () {
    var reader = new FileReader();
    reader.onloadend = function () {
      callback(reader.result);
    };
    reader.readAsDataURL(xhr.response);
  };
  xhr.open("GET", url);
  xhr.responseType = "blob";
  xhr.send();
}

async function shareEsimFallback(imageUrl, iccid) {
  toDataURL(imageUrl, function (data) {
    let imageLink = document.createElement("a");
    imageLink.href = data;
    imageLink.target = "_blank";
    imageLink.download = iccid + ".png";
    imageLink.click();
  });
}

async function shareEsimQrCode(imageUrl, iccid) {
  let response = await fetch(imageUrl);
  let data = await response.blob();
  let metadata = {
    type: "image/png",
  };
  let file = new File([data], `${iccid}.png`, metadata);

  if (!navigator.canShare) {
    shareEsimFallback(imageUrl, iccid);
    return;
  }

  let isIOS = false;
  let userAgent = navigator.userAgent || window.opera;
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    isIOS = true;
  }

  if (navigator.canShare(file)) {
    try {
      if (isIOS) {
        await navigator.share({
          files: [file]
        });
      }
      else {
        await navigator.share({
          files: [file],
          title: installWizardTranslations.share_and_scan.share_subject,
          text: installWizardTranslations.share_and_scan.share_message,
        });
      }
    } catch (error) {
      if (error.name !== "AbortError") {
        shareEsimFallback(imageUrl, iccid);
      }
    }
  } else {
    shareEsimFallback(imageUrl, iccid);
  }
}

function esimInstallNeedHelp() {
  closeEsimInstall();

  if (window.ENABLE_NLX_CHAT) {
    // NLX Chat
    if (document.getElementById('widget-container')) {
      document.querySelector("#widget-container > button").click();
      return;
    }
  } else {
    // Shopify Inbox
    if (document.getElementById('shopify-chat')) {
      document.getElementById('shopify-chat').contentWindow.document.querySelector(".chat-toggle").click();
      return;
    }
  }

  openInstallGuideFallback();
}
